import script from "./sceneInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./sceneInfo.vue?vue&type=script&setup=true&lang=js"

import "./sceneInfo.vue?vue&type=style&index=0&id=4796ec86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4796ec86"]])

export default __exports__